import { Typography } from "@mui/material";
import "./StreamErrorNotice.css";
const StreamErrorNotice = () => {
  return (
    <>
      <Typography className="error-notice">
        {" "}
        {
          "방송이 안보이시나요?\n새로고침 해주세요.\n저전력 모드 시 방송이 안 보일 수 있습니다.\n저전력 모드를 해제 해주세요."
        }
      </Typography>
    </>
  );
};

export default StreamErrorNotice;
